import { render, staticRenderFns } from "./OrderCommentUpdate.vue?vue&type=template&id=2ac3feac&"
import script from "./OrderCommentUpdate.vue?vue&type=script&lang=ts&"
export * from "./OrderCommentUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports